<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="4"
          v-for="field in params.fields"
          :key="field.name"
        >
          <v-text-field
            v-if="field.type == 'varchar'"
            v-model="fieldValues[field.name]"
            :label="field.label"
            required
            outlined
          />
          <v-select
            v-if="field.type == 'references'"
            :items="field.referencesData"
            :placeholder="field.value"
            v-model="referensValues[field.name]"
            item-text="transName"
            @change="selectIdPreferences(field.name)"
            required
            outlined
            return-object
          />
          <v-textarea
            v-if="field.type == 'textarea'"
            v-model="fieldValues[field.name]"
            :label="field.label"
            outlined
            rounded
            height="100"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-btn @click="save" small outlined color="primary">
            {{ $t('Сохранить') }}
          </v-btn>
          <v-btn @click="cancel" class="ml-2" small outlined>
            {{ $t('Отмена') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import LAW from '@/model/law'

  export default {
    props: {
      params: Object
    },
    data: () => ({
      load: false,
      fieldValues: {},
      referensValues: {},
      baseUrl: process.env.VUE_APP_BACK_URL
    }),
    mounted() {
      let self = this

      this.params.fields.forEach(function (field) {
        self.$set(self.fieldValues, field.name, field.value)
      })
    },
    methods: {
      selectIdPreferences(name) {
        this.fieldValues[name] = this.referensValues[name].id
      },
      save() {
        LAW.updateLaw(this.fieldValues, this.$route.params.id).then((response) => {
          this.$emit('update-field', {
            status: true,
            fieldName: this.params.name,
            law: response.data
          })
        })
      },
      cancel() {
        this.$emit('update-field', {
          status: true,
          fieldName: this.params.name
        })
      }
    }
  }
</script>
